import { Currency, TOKEN_ICONS } from '@/constants';

const useTokenIconByCurrency = (currency?: Currency) => {
  const getChainIcon = (currency: Currency): string => {
    return TOKEN_ICONS[currency] || '';
  };

  return { icon: currency ? getChainIcon(currency) : undefined, getChainIcon };
};

export default useTokenIconByCurrency;
